import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=c248bb24&scoped=true&lang=html&"
import script from "./InventoryTable.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c248bb24",
  null
  
)

export default component.exports